import React, {Component} from "react"
import {Link} from "react-router-dom"
import moment from "moment"
import {Location} from "~/utils/ShelfEntities"
import Button from "~/components/Button"
import {handleDestroyError} from "."
import {withTranslation} from "react-i18next"

const icon = require("~/icons/location_32_blue.svg")
const icon_delete = require("~/icons/action_delete.svg")
const icon_edit = require("~/icons/action_edit.svg")

class ListItemStoragePlace extends Component {
  destroyLocation() {
    if (window.confirm(this.props.t("locations.deleteConfirmation"))) {
      Location.destroy(this.props.barcode)
        .then(() => this.props.update())
        .catch(handleDestroyError)
    }
  }
  render() {
    const storagePlace = this.props.storage_place
    let url = null

    if (storagePlace && storagePlace.type === "Location") {
      url = `/location/${storagePlace.barcode}`
    }

    if (storagePlace && storagePlace.type === "Destination") {
      url = `/destination/${storagePlace.id}`
    }

    return (
      <div className="sh-list-item">
        <img src={icon} alt={"Location"} />
        <div className="content">
          {storagePlace && (
            <Link to={url}>
              <div className="primary">{storagePlace.name}</div>
              <div className="secondary">
                {this.props.t("locations.detail.quantity", {
                  quantity: this.props.quantity || 0
                })}
              </div>

              <div className="secondary">
                {this.props.t("locations.detail.lastInventory", {
                  timestamp: this.props.inventories
                    ? moment(`${this.props.inventories.created_at}Z`).format(
                        "DD.MM.YYYY, HH:mm"
                      )
                    : "n/a"
                })}
              </div>
            </Link>
          )}
        </div>

        {!this.props.disableActions && (
          <div className="actions">
            <Button
              onClick={this.destroyLocation.bind(this)}
              icon={icon_delete}
              label={this.props.t("locations.detail.delete")}
            />
            <Button
              to={"/locations/" + this.props.barcode}
              icon={icon_edit}
              label={this.props.t("locations.detail.edit")}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(ListItemStoragePlace)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemStoragePlace.js